/**
 * Copyright (c) 2022 Cedalo GmbH
 */

import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	Paper,
	Tooltip,
	Typography
} from '@mui/material';
import InfoIcon from '@mui/icons-material/esm/InfoOutlined';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DialogButton from '@cedalo/webui/src/ui/utils/DialogButton';
import { ConnectionIcon } from '@cedalo/webui/src/ui/sheeteditor/connections/ConnectionIcon';

const createInfoButton = ({ url }, onClick) => {
	return (
		<Tooltip
			enterDelay={300}
			title={
				<FormattedMessage
					id="Tooltip.Account.Info"
					defaultMessage="For additional information open {url}"
					values={{ url }}
				/>
			}
		>
			<InfoIcon
				style={{
					marginRight: '10px',
					fontSize: '1.5rem'
				}}
				onClick={onClick}
			/>
		</Tooltip>
	);
};
export const CreateAccountDialog = ({ onClose, onNewAccount, delegate }) => {
	const [accountModules, setAccountModules] = useState(null);

	const onAddAccount = async (type) => {
		const result = await delegate.createAccount(type);
		if (result.success) {
			onNewAccount(result.id);
		} else {
			console.error(result.message);
		}
		onClose();
	};
	const onInfo = ({ url }) => {
		return (ev) => {
			console.log(`OPEN URL: ${url}`);
			if (url) window.open(url, '_blank');
			ev.preventDefault();
			ev.stopPropagation();
		};
	};
	useEffect(() => {
		const run = async () => setAccountModules(await delegate.getAccountModules());
		run();
	}, []);

	return (
		<Dialog open onClose={onClose} maxWidth={false}>
			<DialogTitle>
				<FormattedMessage id="DialogNew.title" defaultMessage="New" />
			</DialogTitle>
			<DialogContent
				style={{
					height: '480px',
					minWidth: '600px'
				}}
			>
				<Box sx={{ display: 'flex', gap: '8px', marginTop: '25px', flexDirection: 'column' }}>
					{accountModules
						? accountModules.map((cm) => (
								<Paper key={cm.id} onClick={() => onAddAccount(cm.id)} style={{ cursor: 'pointer' }}>
									<Box p={2} sx={{ display: 'flex', flexDirection: 'column' }}>
										<Box
											sx={{
												display: 'grid',
												gridGap: '8px',
												gridTemplateColumns: '24px 1fr 24px'
											}}
										>
											<ConnectionIcon src={cm.logo} />
											<Typography variant="h6">{cm.name}</Typography>
											{cm.info ? createInfoButton(cm.info, onInfo(cm.info)) : null}
										</Box>
										<Typography variant="subtitle1">{cm.description}</Typography>
									</Box>
								</Paper>
						  ))
						: 'LOADING'}
				</Box>
			</DialogContent>
			<Divider />
			<DialogActions>
				<DialogButton margin defaultButton onClick={onClose}>
					<FormattedMessage id="Cancel" defaultMessage="Cancel" />
				</DialogButton>
			</DialogActions>
		</Dialog>
	);
};
